/**
 *
 * PublicRegister
 *
 */

import React, { useContext, useEffect, useRef, useState } from "react";
import "./style.css";

import Title from "antd/es/typography/Title";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
  Steps,
} from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { FiUserCheck } from "react-icons/fi";
import { CgSwiss } from "react-icons/cg";
import { Helmet } from "react-helmet";
import Logo from "../../../theme/images/logo_oseo_valais_retina.png";
import { UserContext } from "../../../engine/context/User.context";
import back from "../../../theme/images/back.jpeg";
import { listProfiles, renderUserName } from "../../../utils/constants";
import { IoKeyOutline } from "react-icons/io5";
import { getUserByToken } from "../../../engine/api/apiRequest";
import { router } from "../../../engine/router/AppRouter";

const { Step } = Steps;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};

export default function PublicRegister() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [current, setCurrent] = useState(0);
  const [currentError, setCurrentError] = useState(null);
  const [userData, setUserData] = useState(null);
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const token = searchParams.get("token");

  useEffect(() => {
    const initUserToken = async () => {
      try {
        let user = await getUserByToken(token);

        if (user === "") {
          navigate("/", { replace: true });
          notification.error({
            message: `Ce lien n'est plus valable`,
          });
        } else {
          setUserData(user);
          form.setFieldsValue({
            email: user.email,
            lastname: user.info.lastname,
            firstname: user.info.firstname,
            // phone: user.info.phone,
          });
        }
      } catch (e) {
        if (e.response.status === 400) {
          notification.error({
            message: "Ce lien d'invitation a expiré.",
            duration: 5000,
          });

          try {
            navigate("/", { replace: true });
          } catch (e) {
            console.log(e);
          }
        }
        console.log(e);
      }
    };

    if (token === null) {
      navigate("/", { replace: true });
    } else {
      initUserToken();
    }
  }, []);

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const app = useContext(UserContext);

  const [errorRegister, setErrorRegister] = useState("");
  const [registerSuccess, setRegisterSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [engagement, setEngagement] = useState(false);

  useEffect(() => {
    if (errorRegister.length > 0 && errorRegister === "email") {
      notification.error({
        message: "Cet email est déja dans notre systéme !",
      });
    }
  }, [errorRegister]);

  const onFinish = async values => {
    const data = form.getFieldsValue(true);

    setLoading(true);

    const mergedData = {
      password: data.password,
      // info: {
      //   firstname: data.firstname,
      //   phone: data.phone,
      //   lastname: data.lastname,
      // },
    };

    const register = await app.registerNewUser(mergedData, token);
    if (register === true) {
      // register worked well
      setRegisterSuccess(true);
    } else {
      setErrorRegister(register);
    }
    setLoading(false);
  };

  const ref = useRef();

  const validateStep = async step => {
    let valide = true;
    let error = false;

    switch (step) {
      case 0:
        try {
          let validator = await form.validateFields([
            "email",
            "password",
            "confirm",
            "accept",
          ]);
          setCurrentError(null);
        } catch (e) {
          setCurrentError(step);
          error = true;
        }
        break;
      case 1:
        try {
          let validator = await form.validateFields([
            "lastname",
            "firstname",
            "phone",
            "birthdate",
          ]);
          setCurrentError(null);
        } catch (e) {
          setCurrentError(step);
          error = true;
        }
        break;
      case 2:
        try {
          // let validator = await form.validateFields(['company', ']);
          setCurrentError(null);
        } catch (e) {
          setCurrentError(step);
          error = true;
        }
        break;
    }

    if (!error && step <= 1) {
      next();
    }
  };

  // GiHouseKeys, FiUserCheck, FaShippingFast
  const steps = [
    {
      title: "Identifiants",
      icon: <IoKeyOutline />,
      content: (
        <Row className="register-forms" gutter={[10, 10]}>
          {userData && (
            <>
              <Title level={3}>Bienvenue {renderUserName(userData)}</Title>
            </>
          )}

          <Title level={4}>
            Veuillez définir un mot de passe pour activer votre compte
          </Title>
          <Col span={24}>
            <Form.Item
              disabled={true}
              normalize={value => (value || "").toLowerCase()}
              label={"Votre email"}
              name="email"
              rules={[
                {
                  type: "email",
                  message: "Cet email est erroné",
                },
                {
                  required: true,
                  message: "Merci de renseigner votre email",
                },
              ]}
            >
              <Input disabled={true} />
            </Form.Item>
            <Form.Item
              name="password"
              label={"Mot de passe"}
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir votre mot de passe !",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (value.length < 5) {
                      return Promise.reject(
                        new Error(
                          "Votre mot de passe doit faire minimum 5 caractères",
                        ),
                      );
                    }
                    return Promise.resolve();
                  },
                }),
              ]}
              hasFeedback
            >
              <Input.Password />
            </Form.Item>
            <Form.Item
              name="confirm"
              label={"Confirmer le mot de passe"}
              dependencies={["password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Veuillez saisir votre mot de passe !",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      if (
                        value === undefined ||
                        getFieldValue("password") === undefined
                      ) {
                        return Promise.reject(new Error("Mot de passe vide"));
                      }

                      // if (!/[a-z]/.test(value)) {
                      //   return Promise.reject(
                      //     new Error(
                      //       'Votre mot de passe doit avoir au moins une lettre',
                      //     ),
                      //   );
                      // }

                      if (value.length < 5) {
                        return Promise.reject(
                          new Error(
                            "Votre mot de passe doit faire minimum 5 caractères",
                          ),
                        );
                      }

                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "Les deux mots de passe que vous avez saisis ne correspondent pas !",
                      ),
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
            <br />
            <a
              href={
                "https://www.oseo-vs.ch/wp-content/uploads/2023/09/engagement_confidentialite_plateforme_avic.pdf"
              }
            >
              Engagement de Confidentialité relatif à la Plateforme AVIC
            </a>
            <br />
            <br />
            <label>
              <Checkbox
                checked={engagement}
                onChange={() => {
                  setEngagement(!engagement);
                }}
              />
              <span style={{ marginLeft: 20 }}>Je confirme et m'engage</span>
            </label>
          </Col>
        </Row>
      ),
    },
    // {
    //   title: "Informations",
    //   icon: <FiUserCheck />,
    //   content: (
    //     <Row className="register-forms" gutter={[10, 10]}>
    //       <Title level={3}>Quels sont vos informations ?</Title>
    //       <Col span={24}>
    //         <Form.Item
    //           name="lastname"
    //           label={"Votre nom"}
    //           style={{ width: "100%" }}
    //           rules={[
    //             {
    //               required: true,
    //               message: "Merci de renseigner votre nom",
    //               whitespace: true,
    //             },
    //           ]}
    //         >
    //           <Input />
    //         </Form.Item>
    //         <Form.Item
    //           name="firstname"
    //           label={"Votre prénom"}
    //           style={{ width: "100%" }}
    //           rules={[
    //             {
    //               required: true,
    //               message: "Merci de renseigner votre prénom",
    //               whitespace: true,
    //             },
    //           ]}
    //         >
    //           <Input />
    //         </Form.Item>
    //         <Form.Item
    //           name="phone"
    //           label={"Votre téléphone"}
    //           rules={[
    //             {
    //               pattern: /^\+?([1-9][0-9]{0,1})\)?[-. ]?([0-9]{4})[-. ]?([0-9]{4})$/,
    //               required: true,
    //               message: "Veuillez saisir votre numéro de téléphone !",
    //             },
    //           ]}
    //         >
    //           <Input
    //             placeholder={"791234567"}
    //             style={{ width: "100%" }}
    //             addonBefore={"+41"}
    //           />
    //         </Form.Item>
    //       </Col>
    //     </Row>
    //   ),
    // },
    // {
    //   title: "Confirmation",
    //   icon: <CgSwiss />,
    //   content: (
    //     <>
    //       <Row className="register-forms" gutter={[10, 10]}>
    //         <Title level={3}>Merci d'avoir validé vos informations.</Title>
    //         <p>
    //           En vous connectant ultérieurement à votre espace, vous pourrez
    //           modifier davantage d'informations.
    //         </p>
    //       </Row>
    //     </>
    //   ),
    // },
  ];

  const renderStatusStep = index => {
    if (currentError === index) {
      return "error";
    }

    if (index === current) {
      return "process";
    }

    if (current > index) {
      return "finish";
    }

    return "wait";
  };

  return (
    <div id={"registerPage"} style={{ backgroundImage: "url(" + back + ")" }}>
      <Helmet>
        <title>OSEO - S'inscrire</title>
        <meta name="description" content="Description of PublicLogin" />
      </Helmet>
      <Card className={"center-vw-full registerBG"}>
        {registerSuccess ? (
          <div style={{ textAlign: "center", padding: 20 }}>
            <img
              src={Logo}
              style={{
                width: "200px",
                margin: "0 auto",
                display: "block",
                marginTop: "0px",
              }}
            />
            <br />
            <Title level={2}>Félicitations pour votre inscription ! 🎉</Title>
            <br />
            <p style={{ fontSize: "20px" }}>
              Nous sommes ravis de vous accueillir en tant que nouveau membre
              OSEO Valais.
              <br /> <br />
              Nous mettons tout en œuvre pour rendre votre expérience
              exceptionnelle. Si vous avez des questions ou besoin d'assistance,
              n'hésitez pas à nous contacter. Notre équipe se tient à votre
              disposition.
            </p>
            <p style={{ fontSize: "20px" }}>docs@oseo-vs.ch</p>
            <Link to={"/auth"}>
              <Button style={{ maxWidth: "300px" }} type={"primary"}>
                Se connecter maintenant
              </Button>
            </Link>
          </div>
        ) : (
          <Form
            ref={ref}
            tabIndex={0}
            {...formItemLayout}
            form={form}
            layout={"vertical"}
            name="register"
            onFinish={onFinish}
          >
            <Steps
              current={current}
              type="navigation"
              responsive
              className="site-navigation-steps"
            >
              {steps.map((item, k) => (
                <Step
                  key={item.title}
                  title={item.title}
                  icon={item.icon}
                  status={renderStatusStep(k)}
                />
              ))}
            </Steps>

            <div className="steps-content">{steps[current].content}</div>
            <div className="steps-action">
              {/*{current > 0 && (*/}
              {/*  <Button style={{ width: "50%" }} onClick={() => prev()}>*/}
              {/*    Précédent*/}
              {/*  </Button>*/}
              {/*)}*/}
              {/*{current < steps.length - 1 && current !== 0 ? (*/}
              {/*  <Button*/}
              {/*    type="primary"*/}
              {/*    onClick={() => validateStep(current)}*/}
              {/*    style={{ width: "calc(50% - 15px)", marginLeft: "10px" }}*/}
              {/*  >*/}
              {/*    Prochaine étape*/}
              {/*  </Button>*/}
              {/*) : null}*/}
              {/*{current === 0 && (*/}
              {/*  <Button*/}
              {/*    type="primary"*/}
              {/*    onClick={() => validateStep(current)}*/}
              {/*    style={{ width: "100%" }}*/}
              {/*  >*/}
              {/*    Prochaine étape*/}
              {/*  </Button>*/}
              {/*)}*/}
              {/*{current === steps.length - 1 && (*/}
              {/*  <Button*/}
              {/*    type="primary"*/}
              {/*    htmlType="submit"*/}
              {/*    //disabled={loading}*/}
              {/*    // loading={loading}*/}
              {/*    style={{ width: "100%" }}*/}
              {/*    onClick={() => validateStep(current)}*/}
              {/*  >*/}
              {/*    Confirmer le compte*/}
              {/*  </Button>*/}
              {/*)}*/}

              <Button
                disabled={!engagement}
                type="primary"
                htmlType="submit"
                //disabled={loading}
                // loading={loading}
                style={{ width: "250px" }}
                onClick={() => form.submit()}
              >
                Confirmer mon compte
              </Button>
            </div>
            <p style={{ color: "#ff4d4f" }}>
              {errorRegister === "email" &&
                "Cet email est déja dans notre systéme !"}
            </p>
            <Col span={12}>
              <Link to={"/"}>
                <p>Je possède un compte</p>
              </Link>
            </Col>
          </Form>
        )}
      </Card>
    </div>
  );
}
